import type { CookieCircuitBreakerConfig } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
import { CookieCircuitBreaker } from './CookieCircuitBreaker.tsx';

let circuitBreaker: CookieCircuitBreaker | undefined;

/*
 * This function only constructs a single cookie circuit breaker the first time it is called.
 * Subsequent calls will return the already constructed cookie circuit breaker.
 * It is only intended to be called during an SSR request
 *
 * getCookieCircuitBreaker is NOT designed to be called anywhere else.
 */
export function getCookieCircuitBreaker(
	config: CookieCircuitBreakerConfig,
): CookieCircuitBreaker | undefined {
	if (config?.isSetCookieEnabled) {
		if (circuitBreaker) {
			return circuitBreaker;
		}
		circuitBreaker = new CookieCircuitBreaker(config);
		return circuitBreaker;
	}
}
